<div
  class="page-container"
  fxLayout="row"
  fxLayout.xs="column"
  fxLayoutAlign="center center"
  fxLayoutAlign.xs="center center"
>
  ERROR 403 (You are not allowed to view this page)
</div>
